export default /* glsl */`
highp vec3 smoothmixvec3(vec3 color0, vec3 color1, float edge0, float edge1, float x) {
    highp float ratio = smoothstep(edge0, edge1, x);
    return mix(color0, color1, ratio);
}

highp float smoothmixfloat(float val0, float val1, float edge0, float edge1, float x) {
    highp float ratio = smoothstep(edge0, edge1, x);
    return mix(val0, val1, ratio);
}
`;
